module.exports = __webpack_public_path__ + "static/media/sbg1.af8dbb87.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/active20/sbg1.png
// module id = 811
// module chunks = 0